<template>
  <b-container fluid class="h-100-trim-header-footer mb-5" id="tailie-size">
    <b-row>
      <b-col id="tailie-agree-terms">
        <div id="tailie-terms">
          <!--suppress XmlDuplicatedId -->
          <p v-if="this.shouldAccept" class="font-weight-bold">
            {{ hey }} {{ firstName }}, {{ updated }} {{ termsOfUseTitle }}
          </p>
          <!--suppress XmlDuplicatedId -->
          <p v-else class="font-weight-bold">
            {{ termsOfUseTitle }}
          </p>
          <nl2br tag="p" :text="termsOfUse.text" class-name="tailieText" />
        </div>
      </b-col>
    </b-row>
    <b-row v-if="this.shouldAccept">
      <b-col>
        <div class="tailie-checkbox">
          <b-checkbox v-model="agreed" />
          <p class="tailie-termsofuse-checkbox">
            {{ agreeMessage }} {{ termsOfUseTitle }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <!--suppress XmlDuplicatedId -->
        <b-button
          v-if="this.shouldAccept"
          id="tailie-terms-confirm"
          variant="primary"
          @click="agree"
        >
          {{ agreedText }}
        </b-button>
        <!--suppress XmlDuplicatedId -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import Nl2br from "vue-nl2br";

export default {
  name: "legal-terms-of-use",
  components: {
    Nl2br
  },
  data() {
    return {
      termsOfUseTitle: "Terms Of Use",
      hey: "Hey",
      updated: "we've updated our",
      agreeMessage: "I have read and agree to the",
      agreed: null,
      agreedText: "I agree",
      returnText: "Return"
    };
  },
  props: {
    shouldAccept: Boolean
  },
  created() {
    if (this.shouldAccept) {
      this.$store.dispatch("users/getMe");
    }
    this.$store.dispatch("termsOfUse/getLatestTermsOfUse");
  },
  computed: {
    ...mapGetters({
      firstName: "users/getSelfFirstName",
      termsOfUse: "termsOfUse/getLatestTermsOfUse"
    })
  },
  methods: {
    agree(evt) {
      evt.preventDefault();
      if (this.agreed) {
        this.$store
          .dispatch("termsOfUse/confirm", this.termsOfUse._id)
          .then(() => this.$router.push({ name: "overview" }));
      }
    }
  }
};
</script>
